import React from 'react'
import styled from 'styled-components'
import TextInput from 'react-autocomplete-input'
import 'react-autocomplete-input/dist/bundle.css'

const InputContainer = styled.div`
    position: relative;
    border-bottom: 2px solid transparent;
    color: rgba(0, 0, 0, 0.54);
    display: flex;
    flex-direction: column;

    ul {
        margin: 0;
        border-radius: 4px;
        width: 100%;
        border: 0;
        padding: 8px 0;
        max-height: 190px;
        overflow-y: auto;
        left: 0 !important;
        box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
    }

    li {
        font-size: 16px;
        padding: 6px 16px !important;
        color: #4a4a4a !important;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
		line-height: 1.5;

        strong {
            font-weight: normal;
        }
    }

    li.active {
        background-color: rgba(0, 0, 0, 0.04) !important;
        color: #4a4a4a !important;
    }

    label {
        padding: 0;
        font-size: 12px;
    }

    &:after {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        bottom: -2px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.42);
    }

    :focus-within {
        color: rgb(45, 65, 148);
    }

    :hover:not(:focus-within) {
        border-bottom: 2px solid #4a4a4a;
    }

    input {
        padding: 6px 0 5px 0;
        width: 100%;
        height: 100%;
        color: #4a4a4a;
    }

    textarea {
        padding: 5px 0;
        width: 100%;
        height: 100%;
        color: #4a4a4a;
        resize: none;
        box-sizing: border-box;
        line-height: 20px;
    }

    span {
        width: 100%;
        height: 100%;
        display: block;

        + div {
            left: 0;
            right: 0;
            bottom: -2px;
            z-index: 1;
            content: "";
            position: absolute;
            transform: scaleX(0);
            transition: transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms;
            border-bottom: 2px solid #415dd4;
            pointer-events: none;
        }

        :focus-within {
            + div {
                transform: scaleX(1);
                display: block;
            }
        }
    }
`

export default ({component, value, label, options, onChange, style}) => (
    <InputContainer style={{...style}}>
        <label> {label} </label>
        <TextInput
            Component={component}
            onChange={onChange}
            options={options ? [...new Set(options)] : []}
            value={value}
            className='autocomplete'
            offsetY={25}
            maxOptions={options ? options.length : 10}
            matchAny={true}
        />
        <div />
    </InputContainer>
)
